import { render, staticRenderFns } from "./BookCreateUpdate.vue?vue&type=template&id=1c524b24"
import script from "./BookCreateUpdate.vue?vue&type=script&lang=js"
export * from "./BookCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports